import { ClipboardTextClockOutlineIcon } from './ClipboardTextClockOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 9A710A09-DB02-441E-A5E6-204937893D50
 * name clipboard-text-clock-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-text-clock-outline.svg
 * tags
 * - Date / Time 
 */
export const ClipboardTextHistoryOutlineIcon = ClipboardTextClockOutlineIcon;
export default ClipboardTextHistoryOutlineIcon